import { render, staticRenderFns } from "./WebPageLegacy.vue?vue&type=template&id=02d5a064&scoped=true"
import script from "./WebPageLegacy.vue?vue&type=script&lang=js"
export * from "./WebPageLegacy.vue?vue&type=script&lang=js"
import style0 from "./WebPageLegacy.vue?vue&type=style&index=0&id=02d5a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5a064",
  null
  
)

export default component.exports